var BrandGroup;
(function (BrandGroup) {
    BrandGroup["Stepstone"] = "Stepstone";
    BrandGroup["Totaljobs"] = "Totaljobs";
    BrandGroup["Jobsite"] = "Jobsite";
    BrandGroup["Partners"] = "Partners";
    BrandGroup["Saon"] = "Saon";
})(BrandGroup || (BrandGroup = {}));
export default BrandGroup;
//# sourceMappingURL=BrandGroup.js.map